import { makeStyles } from '@material-ui/core';
import { BatteryChargingFullOutlined } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { DATE_TIME_FORMAT_NO_TIME, formatDate } from '../modules/date-helpers';
import { SourceRegisterCarDetailStateOfHealth } from '../modules/generated/api';
import { getLabel, stateOfHealthQueryTypes } from '../modules/labels';

import IconValue from './IconValue';
import InfoTooltip from './InfoTooltip';
import UnitValue from './UnitValue';

type CarDetailTileBatteryProps = {
  batteryCapacityGross?: number;
  stateOfHealth?: SourceRegisterCarDetailStateOfHealth;
};

const useStyles = makeStyles((theme) => ({
  battery: {
    ...theme.typography.body1,
    fontWeight: theme.typography.fontWeightBold as number,
  },
  sohRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
}));

const CarDetailTileBattery = ({ batteryCapacityGross, stateOfHealth }: CarDetailTileBatteryProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const condition = stateOfHealth?.condition;

  return (
    <IconValue icon={BatteryChargingFullOutlined} label={t('car.batteryCapacityGross')} padding>
      <div className={classes.battery}>
        {batteryCapacityGross !== undefined && (
          <div>
            <UnitValue value={batteryCapacityGross} unit="kWh" />
          </div>
        )}
        {condition !== undefined && (
          <div className={classes.sohRow}>
            <span>
              {t('car.stateOfHealth_abbr')}: <UnitValue value={condition} unit="%" />
            </span>
            <InfoTooltip
              title={t('car.stateOfHealth')}
              placement="bottom"
              hint={
                <>
                  {stateOfHealth?.queryType && (
                    <div>
                      {t('car.stateOfHealthQueryType')}: {getLabel(stateOfHealthQueryTypes, stateOfHealth.queryType)}
                    </div>
                  )}
                  {stateOfHealth?.queryMileage !== undefined && (
                    <div>
                      {t('car.stateOfHealthQueryMileage')}: <UnitValue value={stateOfHealth.queryMileage} unit="km" />
                    </div>
                  )}
                  {stateOfHealth?.queryDate && (
                    <div>
                      {t('car.stateOfHealthQueryDate')}: {formatDate(stateOfHealth.queryDate, DATE_TIME_FORMAT_NO_TIME)}
                    </div>
                  )}
                </>
              }
              xsIcon
            />
          </div>
        )}
      </div>
    </IconValue>
  );
};

export default CarDetailTileBattery;
